import React from 'react';

export default function ProgressSteps({ currentStep = 0, steps = [], onStepClick }) {
	return (
		<div className="w-full">
			<div className="hidden sm:flex items-center justify-between">
				{steps.map((s, idx) => {
					const done = idx < currentStep;
					const current = idx === currentStep;
					return (
						<button
							type="button"
							key={s}
							onClick={() => onStepClick?.(idx)}
							className={`flex-1 flex items-center gap-2 px-2 py-1 rounded ${
								current ? 'text-primary-700' : done ? 'text-green-700' : 'text-gray-500'
							}`}
						>
							<span
								className={`w-6 h-6 rounded-full text-xs flex items-center justify-center border ${
									current ? 'bg-primary-600 text-white border-primary-600' : done ? 'bg-green-600 text-white border-green-600' : 'border-gray-300'
								}`}
							>
								{done ? '✓' : idx + 1}
							</span>
							<span className="text-sm">{s}</span>
						</button>
					);
				})}
			</div>
			<div className="sm:hidden flex items-center justify-center gap-2 mt-2">
				{steps.map((_, idx) => (
					<span key={idx} className={`w-2 h-2 rounded-full ${idx === currentStep ? 'bg-primary-600' : 'bg-gray-300'}`} />
				))}
			</div>
			<div className="mt-2 h-2 bg-gray-200 rounded">
				<div className="h-2 bg-primary-600 rounded" style={{ width: `${Math.round(((currentStep + 1) / steps.length) * 100)}%` }} />
			</div>
		</div>
	);
}


